import React, { useState } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Image,
  Form,
  Input,
  Button
} from '@lockerpm/design';

import { } from "@ant-design/icons";

import HelloImg from '../../../assets/images/hello.svg';

import global from "../../../config/global";
import commonServices from "../../../services/common";
import workspaceServices from "../../../services/workspace";

const CreateWorkspace = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const workspaceName = Form.useWatch('name', form)
  const [callingAPI, setCallingAPI] = useState(false);

  const handleCreateWorkspace = async (values) => {
    setCallingAPI(true);
    await workspaceServices.create({
      name: values.name,
      description: ""
    }).then(async (response) => {
      await commonServices.sync_profile();
      await commonServices.sync_data({ wsId: response.id });
    }).catch((error) => {
      const message = error?.response?.data?.message;
      global.notification('error', t('notification.error.title'), message || t('notification.error.message.default'))
    })
    setCallingAPI(false);
  }

  return (
    <div className="welcome-page">
      <div className="welcome-page__bottom-left"></div>
      <div className="welcome-page__center w-full">
        <Row gutter={[24, 24]} type="flex" align={'middle'} justify={'space-between'}>
          <Col lg={12} md={24}>
            <div className="welcome-page__center--left mt-12 ml-12 h-[340px] flex items-center">
              <div className="w-full text-center px-12">
                <Image
                  src={HelloImg}
                />
                <p className="mt-3">
                  {t('create_workspace.description')}
                </p>
              </div>
            </div>
          </Col>
          <Col lg={11} md={24}>
            <div className="pl-12">
              <p className="text-3xl font-semibold">
                { t('create_workspace.title') }
              </p>
              <Form
                form={form}
                layout="vertical"
                className="mt-4"
                initialValues={{ name: '' }}
                onFinish={handleCreateWorkspace}
              >
                <p className="mb-2 font-semibold">
                  {t('create_workspace.workspace_name')}
                </p>
                <Form.Item
                  name={'name'}
                  noStyle
                >
                  <Input
                    size="large"
                    autoFocus
                    disabled={callingAPI}
                    placeholder={t('placeholder.enter')}
                    readOnly={false}
                  />
                </Form.Item>
                <p className="mt-2">
                  {t('create_workspace.note')}
                </p>
                <div className="flex justify-end mt-6">
                  <Button
                    size="large"
                    className="mr-2"
                    disabled={callingAPI}
                    onClick={() => global.navigate('BACK')}
                  >
                    {t('button.cancel')}
                  </Button>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    disabled={!workspaceName || !workspaceName.trim()}
                    loading={callingAPI}
                  >
                    {t('button.create')}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
      <div className="welcome-page__top-right"></div>
    </div>
  );
}

export default CreateWorkspace;